import { FORM_ERROR_CODES, LEAD_ID_KEY } from '../constants';

export const getHelpTextId = (id) => {
    return `${id}-help-text`;
};

export const dropdownRequired = (options, optional) => {
    return options && options.length && !optional;
};

export const getInitialInputState = (fields, fieldsKeysArray) => {
    const initialInputState = {};
    fieldsKeysArray.forEach((key) => {
        const name = fields[key].id;
        const label = fields[key].label;

        if ((!!name && !!label) || name === 'consent') {
            let value = '';

            if (fields[key].type === 'checkbox') {
                value = false;
            } else if (fields[key].type === 'multiSelectionCheckbox') {
                value = [];
            }

            initialInputState[name] = {
                isEmpty: true,
                isInvalidFormat: false,
                isInvalid: false,
                value: value,
                isRequired: fields[key].required,
                isVisible: key === 'otherDetails' ? false : true,
            };
        }
    });

    return initialInputState;
};

const isInvalidFormatString = (key, element) => {
    if (key === 'email') {
        return !element.checkValidity();
    } else if (key === 'company') {
        let invalidPatter = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z ]{2,}$/;
        return invalidPatter.test(element.value);
    } else if (key === 'phone') {
        let trimmedValue = element.value.trim();
        return trimmedValue.length === 0
            ? false
            : !(trimmedValue.replaceAll('-', '').replaceAll('_', '').length === 10);
    }
    return false;
};

export const removeSymbols = (currencyString) => {
    return currencyString.replace(/[^0-9.]+/g, '');
};

export const getPostData = (path, recaptchaToken, submittedFields, leadId = '') => {
    const postData = {
        path: path,
        recaptchaToken: recaptchaToken,
        data: {},
    };
    const dataKeysArray = Object.keys(submittedFields);

    dataKeysArray.forEach((key) => {
        postData.data[key] = submittedFields[key].value;
    });

    postData.data[LEAD_ID_KEY] = leadId;

    return postData;
};

export const handleErrors = (
    error,
    setFieldErrors,
    setNonFieldErrors,
    setInput,
    submittedFields
) => {
    const response = error.response;

    if (response) {
        if (response.status >= 500 && response.status < 600) {
            setFieldErrors({});
            setNonFieldErrors(['INTERNAL_SERVER_ERROR']);
        } else if (response.data) {
            setFieldErrors(response.data.fieldErrors || {});
            setNonFieldErrors(response.data.nonFieldErrors || []);
        }
    } else {
        console.error(error);

        setInput(submittedFields);
    }
};

export const validateForm = (
    fields,
    fieldsKeysArray,
    target,
    input,
    submitAttempted,
    fieldErrors
) => {
    const submittedFields = input;
    let isFormValid = true;

    fieldsKeysArray.forEach((key) => {
        const name = fields[key].id;
        const label = fields[key].label;

        if (!!name && !!label) {
            const element = target[name];
            const value = input[name].value;
            const fieldError = fieldErrors[name];
            let serverErrorMessage;
            let validation;

            if (fieldError) {
                serverErrorMessage = fieldError
                    .map((error) => FORM_ERROR_CODES[error])
                    .join('<br />');
            } else {
                serverErrorMessage = '';
            }

            if (submitAttempted && key !== 'otherDetails') {
                validation = {
                    isEmpty: input[name].isEmpty,
                    isInvalidFormat: input[name].isInvalidFormat,
                    isInvalid: input[name].isInvalid,
                    errorMessage: input[name].errorMessage,
                    serverErrorMessage: serverErrorMessage,
                };
            } else {
                validation = validateInput(fields, key, element, value, fieldError, label, input);
            }

            submittedFields[fields[key].id] = {
                ...submittedFields[fields[key].id],
                ...validation,
            };

            if (key === 'multiSelectionCheckbox') {
                submittedFields[fields[key].id]['value'] =
                    submittedFields[fields[key].id]['value'].toString();
            }

            if (validation.isInvalid) {
                isFormValid = false;
            }
        }
    });

    return {
        submittedFields: submittedFields,
        isFormValid: isFormValid,
    };
};

export const validateInput = (fields, key, element, value, fieldError, label, input = {}) => {
    let isEmpty;
    let isInvalidFormat;
    let isInvalid;
    let errorMessage;
    let serverErrorMessage;

    const fieldRequired =
        Object.keys(input).length > 0 ? input[fields[key].id].isRequired : fields[key].required;

    if (typeof value === 'string') {
        const trimmedValue = value.trim();
        isEmpty = trimmedValue.length === 0;
        isInvalidFormat = isInvalidFormatString(key, element);
    } else if (Array.isArray(value)) {
        isEmpty = value.length === 0;
        isInvalidFormat = false;
    } else {
        isEmpty = !value;
        isInvalidFormat = false;
    }

    if (isEmpty && fieldRequired && !!label) {
        isInvalid = true;
        errorMessage = fields[key].requiredErrorMessage;
    } else if (isInvalidFormat && !!label) {
        isInvalid = true;
        errorMessage = fields[key].invalidErrorMessage;
    } else {
        isInvalid = false;
        errorMessage = '';
    }

    if (fieldError) {
        serverErrorMessage = fieldError.map((error) => FORM_ERROR_CODES[error]).join('<br />');
    } else {
        serverErrorMessage = '';
    }

    return {
        isEmpty: isEmpty,
        isInvalidFormat: isInvalidFormat,
        isInvalid: isInvalid,
        errorMessage: errorMessage,
        serverErrorMessage: serverErrorMessage,
    };
};

export const setOtherDetails = ({ currentFieldName, parentField, parentValue }) => {
    if (currentFieldName === parentField.id) {
        let returnObject = {
            isRequired: parentField.required && parentValue === 'otherOptionSelected',
            isVisible: parentValue === 'otherOptionSelected',
        };
        if (parentValue !== 'otherOptionSelected') {
            returnObject['value'] = '';
        }
        return returnObject;
    }
};

export const getMergeFieldsData = (data) => {
    const ignoredKeys = ['email', 'consent'];
    return Object.keys(data)
        .filter((key) => !ignoredKeys.includes(key))
        .reduce(
            (mergeFieldsData, key) => ({
                ...mergeFieldsData,
                [key.toUpperCase().trim()]: data[key],
            }),
            {}
        );
};
